<!-- 归档的标签管理列表 -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="showSearchDialog">查询（F2）</el-button>
            </div>
        </div>
        <template v-if="noData">
            <div class="no-data">暂无数据</div>
        </template>
        <template v-else>
            <div class="table-ctn">
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :data="tableData"
                    border=""
                    style="width: 100%"
                    @cell-dblclick="handleDBClick"
                    @selection-change="handleSelectionChange"
                    v-loading="loading"
                >
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column width="180px" prop="LabelCode" label="标签码" show-overflow-tooltip></el-table-column>
                    <el-table-column width="80px" prop="PackingSpec" label="商品数" show-overflow-tooltip></el-table-column>
                    <el-table-column width="80px" prop="CostPrice" label="标签成本" show-overflow-tooltip></el-table-column>
                    <el-table-column width="150px" prop="APCode" label="汽配编码" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="150px" prop="GoodName" label="汽配名称" show-overflow-tooltip></el-table-column>
                    <el-table-column width="180px" prop="AutoSerise" label="适用车型" show-overflow-tooltip></el-table-column>
                    <el-table-column width="120" prop="Brand" label="品牌" show-overflow-tooltip></el-table-column>
                    <el-table-column width="120px" prop="Cate" label="汽配分类" show-overflow-tooltip></el-table-column>
                    <el-table-column width="70px" prop="Unit" label="单位" show-overflow-tooltip></el-table-column>
                    <el-table-column width="120px" prop="StorageName" label="存放仓库" show-overflow-tooltip></el-table-column>
                    <el-table-column width="120px" prop="SpaceName" label="存放仓位" show-overflow-tooltip></el-table-column>
                    <el-table-column width="100" show-overflow-tooltip label="标签状态">
                        <template slot-scope="scope">{{ scope.row.State | stateHandle }}</template>
                    </el-table-column>
                    <el-table-column width="80px" prop="Name" label="创建人" show-overflow-tooltip></el-table-column>
                    <!-- <el-table-column width="160px" prop="UpdateTime" label="最后更新时间" show-overflow-tooltip></el-table-column> -->
                    <el-table-column width="160px" prop="CreateTime" label="标签创建时间" show-overflow-tooltip></el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>
        </template>
        <el-dialog :close-on-click-modal="false" title="标签的一生" :visible.sync="LabelLifesVisible" width="1000px">
            <div class="dialog-content" v-if="LabelLifesVisible">
                <goodsLabelLifes :LabelId="LabelId" @closeDialog="closeLabelLifesDialog"></goodsLabelLifes>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="标签搜索"
            :visible.sync="dialogVisible"
            width="400px"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-label-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
        >
            <div class="dialog-content" v-if="dialogVisible">
                <el-form ref="form" label-position="left" label-width="70px">
                    <el-form-item label="标签码">
                        <el-input class="search-item" v-model.trim="searchData.LabelCode" size="small" placeholder="标签码" ref="search_lc"></el-input>
                    </el-form-item>
                    <el-form-item label="标签状态">
                        <el-select class="search-item" size="small" v-model="searchData.State" style="width: 100%">
                            <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否存放">
                        <el-select class="search-item" size="small" v-model="searchData.IsSto" style="width: 100%">
                            <el-option key="-1" label="全部" value=""></el-option>
                            <el-option key="0" label="未存放" value="0"></el-option>
                             <el-option key="1" label="已存放" value="1"></el-option>
                        </el-select>
                    </el-form-item>                    
                    <el-form-item label="汽配编码">
                        <el-input class="search-item" size="small" v-model="searchData.APCode" placeholder="汽配编码"></el-input>
                    </el-form-item>
                    <el-form-item label="汽配名称">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.GoodName"
                            remote
                            filterable
                            allow-create
                            clearable
                            placeholder="请输入配件名称"
                            :remote-method="searchGoodName"
                            v-select-scroll-more="searchGoodNameLoad"
                            popper-class="my-select"
                        >
                            <el-option v-for="item in goodNameOptions" :key="item" :label="item" :value="item"> </el-option>
                            <el-option v-if="optionLoading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="适用车型">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.AutoSerise"
                            remote
                            filterable
                            allow-create
                            clearable
                            placeholder="请输入车型"
                            :remote-method="searchAutoSerise"
                            v-select-scroll-more="searchAutoSeriseLoad"
                            popper-class="my-select"
                        >
                            <el-option v-for="item in autoSeriseOptions" :key="item" :label="item" :value="item" style="width: 300px"> </el-option>
                            <el-option v-if="optionLoading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="品牌">
                        <el-select
                            v-model="searchData.BrandName"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            size="small"
                            style="width: 100%"
                            @visible-change="brandVisibleChange($event)"
                        >
                            <el-option :key="item.Text" v-for="item in brand" :label="item.Text" :value="item.Text"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="汽配分类">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.Cate"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            @visible-change="cateVisibleChange($event)"
                        >
                            <el-option v-for="optionItem in typeList1" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                <div class="option-content">
                                    <div>{{ optionItem.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="标签成本">
                        <div class="flex">
                            <el-select size="small" class="search-item" style="width: 90px" v-model="searchData.Symbol1" clearable placeholder="符号">
                                <el-option key=">=" label=">=" value=">="></el-option>
                                <el-option key=">" label=">" value=">"></el-option>
                                <el-option key="<=" label="<=" value="<="></el-option>
                                <el-option key="<" label="<" value="<"></el-option>
                                <el-option key="=" label="=" value="="></el-option>
                                <el-option key="!=" label="!=" value="!="></el-option>
                                <el-option key="between" label="区间" value="between"></el-option>
                            </el-select>
                            <el-input
                                class="search-item"
                                size="small"
                                style="width: 90px"
                                v-model.trim="searchData.CostPrice1"
                            ></el-input>
                            <el-input class="search-item" size="small" style="width: 90px" v-model.trim="searchData.CostPrice2" v-if="searchData.Symbol1 == 'between'"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="仓库">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.WarehouseId"
                            filterable
                            clearable
                            @visible-change="wHVisibleChange($event)"
                            @change="warehouseChange($event)"
                        >
                            <el-option v-for="optionItem in warehouseList" :key="optionItem.WarehouseId" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId">
                                <div class="option-content">
                                    <div>{{ optionItem.WarehouseName }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="仓位">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.SpaceId"
                            reserve-keyword
                            remote
                            :remote-method="val => remoteMethod(val)"
                            v-select-scroll-more="remoteMethodScrollMore"
                            filterable
                            clearable
                            v-loading="spaceloading"
                        >
                            <el-option v-for="optionItem in spaceList" :key="optionItem.ShelfSpaceId" :label="optionItem.ShelfSpaceCode" :value="optionItem.ShelfSpaceId">
                                <div class="option-content">
                                    <div>{{ optionItem.ShelfSpaceCode }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="创建人">
                        <el-select size="small" style="width: 100%" v-model="searchData.CreatorId" class="search-item" filterable placeholder="请选择" clearable>
                            <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="创建日期">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="datetime1"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate1TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="更新日期">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="datetime2"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate2TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="查询公式">
                        <el-radio-group v-model="searchData.SearchType">
                            <el-radio :label="0">左等</el-radio>
                            <el-radio :label="1">全等</el-radio>
                            <el-radio :label="2">包含</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                    <el-button size="small" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                    <el-button size="small" @click="closeSearchDialog">关闭（Esc）</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import goodsLabelLifes from '@/components/business/goods/goodsLabelArchLifes';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: 'labels',
    components: {
        goodsLabelLifes,
        breadcrumb,
        elTableColumn
    },
    data() {
        return {
            datetime1: '',
            datetime2: '',
            LabelId: '',
            SIdList: [],
            brand: [],
            noData: false,
            typeList1: [],
            LabelLifesVisible: false,
            dialogVisible: false,
            isStopReq: false,
            loading: false,
            searchData: {
                LabelCode: '',
                AutoSerise: '',
                APCode: '',
                BrandName: [],
                GoodName: '',
                Cate: [],
                State: '2',
                StartDate: '',
                EndDate: '',
                UStartDate: '',
                UEndDate: '',
                CreatorId: '',
                page: 1,
                limit: this.commonPageSize,
                SearchType: 2,
                WarehouseId: '',
                SpaceId: '',
                Symbol1: '',
                CostPrice1: 0,
                CostPrice2: 0,
            },
            goodsCategories: [],
            tableData: [],
            tableDataLength: 0,
            permission: {},
            stateList: [
                { Text: '全部', Value: '' },
                { Text: '已离仓', Value: '2' },
                { Text: '已销毁', Value: '1' }
            ],
            multipleSelection: [],
            isStartSearch: false,
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            warehouseList: [],
            spaceList: [],
            spaceloading: false,
            currentShelfSpaceObj: {}, // 当前的下拉框仓位数据
            optionLoading: false,
            goodNameOptions: [],
            goodNameForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            autoSeriseOptions: [],
            autoSeriseForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            }
        };
    },
    //当前页面使用了keepAlive,不会触发beforeDestroy钩子
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        if (this.dialogVisible) this.dialogVisible = false;
        next();
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
    },
    mounted() {
        this.getTableData();
        this.permission = this.$util.getPermission('LabelManagement');
        this.getSIdList();
    },
    filters: {
        stateHandle(value) {
            if (value == 0) {
                return '正常';
            } else if (value == 1) {
                return '已销毁';
            } else if (value == 2) {
                return '已离仓';
            }
        }
    },
    watch: {
        isStartSearch(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    this.$refs.search_lc.focus();
                });
            }
        }
    },
    methods: {
        handleKeyEvent(e) {
            let that = this;
            let key = window.event.keyCode;
            if (key === 113) {
                e.preventDefault();
                this.dialogVisible = true;
                this.isStartSearch = true;
                return;
            }
            if (key === 13) {
                e.preventDefault();
                that.handleSearch();
                return;
            }
            if (key === 27) {
                e.preventDefault();
                if (this.dialogVisible) {
                    this.dialogVisible = false;
                    this.isStartSearch = false;
                }
                return;
            }
            //右键
            if (key === 39) {
                e.preventDefault();
                if (!this.dialogVisible) {
                    let page = that.searchData.page;
                    let limit = that.searchData.limit;
                    let totalPages = Math.ceil(that.tableDataLength / limit);
                    if (page < totalPages) {
                        that.searchData.page += 1;
                        that.getTableData();
                    }
                }
                return;
            }
            //左键
            if (key === 37) {
                e.preventDefault();
                if (!that.dialogVisible) {
                    if (that.searchData.page !== 1) {
                        that.searchData.page -= 1;
                        that.getTableData();
                    }
                }
                return;
            }
        },
        showSearchDialog() {
            this.dialogVisible = true;
            this.isStartSearch = true;
        },
        closeSearchDialog() {
            this.dialogVisible = false;
            this.isStartSearch = false;
        },
        // 配件信息
        showLabelLifesDialog(id) {
            this.LabelId = id;
            this.LabelLifesVisible = true;
        },
        closeLabelLifesDialog() {
            this.LabelLifesVisible = false;
        },
        searchGoodsBrand() {
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brand = data;
                })
                .catch(() => {});
        },
        searchGoodsType() {
            this.$util
                .getEntpApCategoryList()
                .then(data => {
                    if (!data) return;
                    this.typeList1 = data;
                })
                .catch(() => {});
        },
        // 重置表单
        resetSearch() {
            this.searchData = {
                LabelCode: '',
                AutoSerise: '',
                APCode: '',
                BrandName: [],
                GoodName: '',
                Cate: [],
                State: '0',
                StartDate: '',
                EndDate: '',
                CreatorId: '',
                UStartDate: '',
                UEndDate: '',
                page: 1,
                limit: this.commonPageSize,
                SearchType: 2,
                WarehouseId: '',
                SpaceId: '',
                Symbol1: '',
                CostPrice1: 0,
                CostPrice2: 0,
                IsSto:""
            };
            this.datetime1 =[];
            this.datetime2=[];
            this.spaceList = [];
        },
        clearDialog() {
            this.getTableData();
        },
        // 关闭弹窗
        closeDialog(edit) {
            if (edit) {
                this.getTableData();
            }
        },
        // 获取数据
        getTableData() {
            if (!this.isStopReq) {
                this.isStopReq = true;
                this.loading = true;
                this.$util
                    .axiosPost({
                        url: '/api/EntpGoodsLabels/GetArchLabelCodes',
                        data: this.searchData,
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data;
                        if (!data) {
                            this.noData = true;
                            return;
                        }
                        this.noData = false;
                        this.tableData = data;
                        this.tableDataLength = res.count;
                    })
                    .catch(() => {})
                    .finally(() => {
                        this.isStopReq = false;
                        this.loading = false;
                    });
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        //表单双击事件
        handleDBClick(event) {
            if (event.LabelId) {
                this.showLabelLifesDialog(event.LabelId);
            }
        },
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brand.length == 0) that.searchGoodsBrand();
            }
        },
        cateVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.typeList1.length == 0) that.searchGoodsType();
            }
        },
        //选中时间
        onDate1TimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        onDate2TimeSelect(val) {
            if (val != null) {
                this.searchData.UStartDate = val[0];
                this.searchData.UEndDate = val[1];
            } else {
                this.searchData.UStartDate = '';
                this.searchData.UEndDate = '';
            }
        },
        getSIdList() {
            this.$util.getSIdList().then(data => {
                this.SIdList = data;
            });
        },
        wHVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length == 0) {
                    this.$util.getWarehouse().then(data => {
                        this.warehouseList = data;
                    });
                }
            }
        },
        warehouseChange(value) {
            this.spaceList = [];
            this.searchData.SpaceId = '';
            if (value) {
                this.currentShelfSpaceObj = { Page: 1, StopLoad: false };
                this.searchPosition(this.currentShelfSpaceObj);
            }
        },
        // 仓位下拉框滚动加载
        remoteMethodScrollMore() {
            this.remoteMethod();
        },
        /**
         * 搜索仓位
         * 支持远程搜索和滚动下拉加载更多
         *   通过 val 判断是哪种情况，非空时是远程搜索
         */
        remoteMethod(val) {
            let obj = this.currentShelfSpaceObj;
            if (val) {
                // 远程搜索，重置搜索项
                obj.Key = val;
                obj.Page = 1;
                obj.StopLoad = false;
                this.spaceList = [];
            } else {
                // 下拉加载更多
                obj.Page += 1;
            }
            if (obj.StopLoad) return;
            this.searchPosition({
                Key: obj.Key,
                Page: obj.Page
            }).then(() => {
                let row = {
                    ...obj
                    // StopLoad: this.spaceList.length < 20
                };
                this.currentShelfSpaceObj = row;
            });
        },
        // 搜仓位
        searchPosition(obj) {
            let that = this;
            if (!that.searchData.WarehouseId || that.spaceloading) return;
            that.spaceloading = true;
            return that.$util
                .GetShelfSpacesList({
                    WarehouseId: that.searchData.WarehouseId,
                    ShelfSpaceCode: obj.Key,
                    Page: obj.Page,
                    Limit: 20,
                    IsLimit: true,
                    IncludecWaste: true
                })

                .then(res => {
                    that.spaceloading = false;
                    if (res.data) {
                        that.spaceList = that.spaceList.concat(res.data);
                        this.currentShelfSpaceObj.StopLoad = that.spaceList.length >= res.count;
                    } else {
                        that.$util.warningMsg('该仓库暂无仓位');
                    }
                })
                .catch(error => {
                    that.spaceloading = false;
                });
        },
        async searchGoodName(key) {
            if (![undefined].includes(key)) {
                this.goodNameForm.Page = 1;
                this.goodNameForm.stopLoad = false;
                this.goodNameForm.key = key;
                this.goodNameOptions = [];
            }
            if (this.goodNameForm.stopLoad) return;
            this.optionLoading = true;
            const data = await this.$util.searchPartAttr(this.goodNameForm.key, 1, this.goodNameForm.Page, this.goodNameForm.Limit);
            this.optionLoading = false;
            if (data) {
                if (!data) return;
                this.goodNameForm.stopLoad = data.length < this.goodNameForm.Limit;
                this.goodNameOptions = [...this.goodNameOptions, ...data];
            }
        },
        searchGoodNameLoad() {
            this.goodNameForm.Page += 1;
            this.searchGoodName();
        },
        async searchAutoSerise(key) {
            if (![undefined].includes(key)) {
                this.autoSeriseForm.Page = 1;
                this.autoSeriseForm.stopLoad = false;
                this.autoSeriseForm.key = key;
                this.autoSeriseOptions = [];
            }
            if (this.autoSeriseForm.stopLoad) return;
            this.optionLoading = true;
            const data = await this.$util.searchPartAttr(this.autoSeriseForm.key, 2, this.autoSeriseForm.Page, this.autoSeriseForm.Limit);
            this.optionLoading = false;
            if (data) {
                if (!data) return;
                this.autoSeriseForm.stopLoad = data.length < this.autoSeriseForm.Limit;
                this.autoSeriseOptions = [...this.autoSeriseOptions, ...data];
            }
        },
        searchAutoSeriseLoad() {
            this.autoSeriseForm.Page += 1;
            this.searchAutoSerise();
        }
    }
};
</script>
<style lang="less" scoped>
#search-label-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .search-item-dialog {
        width: 340px;
        height: auto;
        .dialog-footer {
            text-align: right;
        }
        .el-form-item {
            margin-bottom: 0;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
</style>